<template>
  <div class="flex items-center justify-center">
    <swiper pagination loop class="w-full h-full">
      <swiper-slide class="relative disclaimer">
        <div class="absolute inset-0">
          <img src="images/GARDEN_21st_FLOOR_FINAL.jpg" srcset="images/GARDEN_21st_FLOOR_FINAL.jpg 1440w, images/GARDEN_21st_FLOOR_FINAL.jpg 3440w" class="object-cover w-full h-full" alt="">
        </div>
        <div class="relative">
          <div class="absolute top-0 right-0 p-16 text-4xl font-bold text-white">
            LIVE ON TOP. LIFE'S ON TOP.
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="grid grid-cols-2 grid-rows-2">
        <div class="relative">
          <div class="absolute inset-0">
            <img src="images/MULTI_PURPOSE.jpg" srcset="images/MULTI_PURPOSE.jpg 1440w, images/MULTI_PURPOSE.jpg 3440w" class="object-cover object-bottom w-full h-full" alt="">
          </div>
        </div>
        <div class="relative">
          <div class="absolute inset-0">
            <img src="images/LAUNDRY.jpg" srcset="images/LAUNDRY.jpg 1440w, images/LAUNDRY.jpg 3440w" class="object-cover w-full h-full" alt="">
          </div>
        </div>
        <div class="relative disclaimer">
          <div class="absolute inset-0">
            <img src="images/Stocksy_1213787.jpg" srcset="images/Stocksy_1213787.jpg 1440w, images/Stocksy_1213787.jpg 3440w" class="object-cover w-full h-full" alt="">
          </div>
        </div>
        <div class="grid bg-white place-items-center">
          <div class="max-w-md space-y-4 text-center xl:space-y-8">
            <h1 class="text-xl font-bold uppercase xl:text-3xl text-primary-500">
              CONVENIENCE AT FIRST GLANCE
            </h1>

            <p class="text-xl font-bold">
              ให้การใช้ชีวิต..ง่ายยิ่งกว่าเคย
            </p>

            <p class="text-lg">
              ความสะดวกสบายที่ครบครัน
              ในพื้นที่ส่วนกลางของโครงการบริเวณ ชั้น 1
              ด้วย Multi Purpose Room
              ตอบโจทย์ของการอยู่อาศัยแบบ Hybrid
              ทั้งพื้นที่นั่งเล่น และทํางาน
              รวมทั้งบริเวณ Laundry ที่สามารถนั่งพักผ่อนได
            </p>
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="grid grid-cols-2 grid-rows-2">
        <div class="relative col-span-2">
          <div class="absolute inset-0">
            <img src="images/FITNESS.jpg" srcset="images/FITNESS.jpg 1440w, images/FITNESS.jpg 3440w" class="object-cover object-bottom w-full h-full" alt="">
          </div>
        </div>
        <div class="grid bg-white place-items-center">
          <div class="max-w-md space-y-4 text-center xl:space-y-8">
            <h1 class="text-xl font-bold uppercase xl:text-3xl text-primary-500">
              Be Adaptive. Stay active.
            </h1>
            <p class="text-lg">
              พื้นที่ออกกำลังกายลอยฟ้าบนชั้น 23
              ด้วยอุปกรณ์ครบครัน ให้คุณออกกำลังกาย
              ได้ทั้งแบบ Passive และ Active
              สร้างวันดีๆ ให้เกิดขึ้นได้ที่นี่
            </p>
          </div>
        </div>
        <div class="relative disclaimer">
          <div class="absolute inset-0">
            <img src="images/shutterstock_525454813.jpg" srcset="images/shutterstock_525454813.jpg 1440w, images/shutterstock_525454813.jpg 3440w" class="object-cover w-full h-full" alt="">
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="grid grid-cols-2 grid-rows-2">
        <div class="relative col-span-2">
          <div class="absolute inset-0">
            <img src="images/POOL_FINAL2.jpg" srcset="images/POOL_FINAL2.jpg 1440w, images/POOL_FINAL2.jpg 3440w" class="object-cover object-bottom w-full h-full" alt="">
          </div>
        </div>
        <div class="relative disclaimer">
          <div class="absolute inset-0">
            <img src="images/Stocksy_327750.jpg" srcset="images/Stocksy_327750.jpg 1440w, images/Stocksy_327750.jpg 3440w" class="object-cover w-full h-full" alt="">
          </div>
        </div>
        <div class="grid bg-white place-items-center">
          <div class="max-w-md space-y-4 text-center xl:space-y-8">
            <h1 class="text-xl font-bold uppercase xl:text-3xl text-primary-500">
              Live a wide open life
            </h1>
            <p class="text-lg">
              กับสระว่ายน้ำระบบน้ำเกลือลอยฟ้า
              ขนาด 25x5 เมตร แยกโซนเด็ก และผู้ใหญ่
              พร้อม Jacuzzi ที่ให้วันพักผ่อนของคุณ สุขกว่าที่เคย
            </p>
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="grid grid-cols-2 grid-rows-2 disclaimer">
        <div class="relative row-span-full">
          <img src="images/LOBBY.jpg" srcset="images/LOBBY.jpg 1440w, images/LOBBY@2x.jpg 3440w" alt="" class="absolute inset-0 object-cover w-full h-full">
        </div>
        <div class="grid p-12 text-center bg-white xl:p-16 place-items-center">
          <div class="max-w-md space-y-4 xl:space-y-8 place-items-center">
            <h1 class="text-xl font-bold uppercase xl:text-3xl text-primary-500">
              HIDEAWAY IN<br>
              YOUR OWN WAY
            </h1>
            <h2 class="text-lg font-bold xl:text-2xl text-primary-500">
              มากไปกว่า ความอุ่นใจ..
            </h2>
            <p class="text-sm xl:text-base">
              ครบครันกับระบบรักษาความปลอดภัย
              Access Control ทั้งเข้าและออก
              และพื้นที่ส่วนกลางของโครงการ
              ด้วย Face Scan และ Pass Card สําหรับรถยนต์
              พร้อม CCTV และ รปภ. 24 ชั่วโมง
              รวมถึงการนัดหมายเข้าพบลูกบ้านด้วย VMS
            </p>
          </div>
        </div>
        <div class="relative">
          <img src="images/shutterstock_1087446167.jpg" srcset="images/shutterstock_1087446167.jpg 1440w, images/shutterstock_1087446167@2x.jpg 3440w" alt="" class="absolute inset-0 object-cover w-full h-full">
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import SwiperCore, { Pagination, Autoplay, Lazy } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

SwiperCore.use([
  Pagination,
  Autoplay,
  Lazy,
])

export default {
  name: 'Facilities',
  components: {
    Swiper,
    SwiperSlide,
  },
}
</script>
